<div class="wrapper flex flex-col gap-[40px]">
  <section class="header-section">
    @if (projectDetails?.cover_photo?.thumb_url) {
      <app-image
        alt="{{ projectDetails?.name }}_picture"
        class="project-image"
        url="{{projectDetails?.cover_photo?.thumb_url}}"
        />
    }
    @if (!projectDetails?.cover_photo?.thumb_url) {
      <div class="project-image project-image-placeholder">
        <mat-icon class="placeholder-icon">apartment</mat-icon>
        <span class="placeholder-initials">{{ projectDetails?.name | slice:0:2 | uppercase }}</span>
      </div>
    }
    <div class="heading-section">
      <div
        class="heading text-type-2"
        [matTooltip]="projectDetails?.name"
        matTooltipPosition="above"
        matTooltipClass="project-name-tooltip">{{ projectDetails?.name }}
      </div>
      <div
        class="sub-heading text-type-10"
        [matTooltip]="projectDetails?.owner_organization?.name + ' (' + sitesCount + (sitesCount !== 1 ? ' sites)' : ' site)')"
        matTooltipPosition="below"
        matTooltipClass="project-name-tooltip">
        {{ projectDetails?.owner_organization?.name }}
        ({{ sitesCount }} site{{ sitesCount !== 1 ? 's' : '' }})
      </div>
    </div>
  </section>
  <section class="content-section">
    <app-tab-group
      [currentUser]="currentUser"
      [displayActivityCodes]="displayActivityCodes"
      [isContractorMode]="isContractorMode"
      >
      @if (displayFilter) {
        <div
          class="filters-section flex flex-row gap-[20px]"
          >
          <app-report-map-data-export
            [projectId]="projectDetails?.uuid || projectDetails?.id || null"
            [projectName]="projectDetails?.name || ''"
            />
          <app-project-details-page-status-site-filter
            [projectId]="projectDetails?.id || null"
            [isDwrReportingHierarchyEnabled]="projectDetails?.source_entity_extra_attributes?.dwr_reporting_hierarchy_enabled === true"
            />
          <app-project-details-page-date-filter
            [defaultDateValue]="defaultDateValue"
            [projectStartDate]="projectDetails?.start_date"
            />
        </div>
      }
      <!-- Documents tab actions: projected into the tab header row, right-aligned (in-flow for Edge/browser resilience) -->
      @if (displayAction && canEditDocuments) {
        <div
          class="documents-actions flex flex-row gap-[24px]"
          data-documents-actions
          >
          <mat-icon (click)="createFolder()" [svgIcon]="'create-folder'" class="file-icon" />
          <mat-icon (click)="addFile()" [svgIcon]="'add-file'" class="file-icon" />
        </div>
      }
    </app-tab-group>
  </section>
</div>
